"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _core = require("@material-ui/core");

var _fearless = require("@zip/react-icons/fearless");

var _react2 = require("@emotion/react");

var css = _interopRequireWildcard(require("./AmountInput.styles"));

var Buttons = _interopRequireWildcard(require("../../../components/input/button/Button"));

var Icons = _interopRequireWildcard(require("../../../components/icon/Icon"));

var _legacy = require("../../../components/legacy");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ShowKeypadLink = function ShowKeypadLink(_ref) {
  var showKeypad = _ref.showKeypad,
      onClick = _ref.onClick;
  return showKeypad ? (0, _jsxRuntime.jsx)("small", {
    children: (0, _jsxRuntime.jsx)(Buttons.Text, {
      onClick: onClick,
      type: "button",
      underline: "none",
      children: "Show keypad"
    })
  }) : null;
};

var AmountInput = /*#__PURE__*/(0, React.forwardRef)(function (_ref2, ref) {
  var onChange = _ref2.onChange,
      value = _ref2.value,
      errorMessage = _ref2.errorMessage,
      props = _objectWithoutProperties(_ref2, ["onChange", "value", "errorMessage"]);

  var inputEl = (0, React.useRef)(null);

  var _useState = (0, React.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      showKeypad = _useState2[0],
      setShowKeypad = _useState2[1];

  var theme = (0, _react2.useTheme)();
  (0, React.useImperativeHandle)(ref, function () {
    return {
      focus: function focus() {
        inputEl.current.focus();
      }
    };
  });
  var onEditClick = (0, React.useCallback)(function () {
    inputEl.current.focus();
  }, [inputEl]);

  var _onBlur = function onBlur(event, callback) {
    // Call onBlur from props first if provided
    if (callback) callback(event);
    setShowKeypad(true);
  };

  var _onFocus = function onFocus(event, callback) {
    if (callback) callback(event);
    setShowKeypad(false);
  };

  var showIcon = (0, _useMediaQuery["default"])(_legacy.breakpoints.up('sm'));

  var onBlurFromProps = props.onBlur,
      onFocusFromProps = props.onFocus,
      propsExcludeBlurAndFocus = _objectWithoutProperties(props, ["onBlur", "onFocus"]);

  return (0, _jsxRuntime.jsxs)("div", {
    css: css.errorContainer,
    children: [(0, _jsxRuntime.jsxs)("div", {
      css: css.inputContainer,
      children: [(0, _jsxRuntime.jsxs)("div", {
        css: css.amountInput,
        children: ["$", (0, _jsxRuntime.jsx)("input", _objectSpread({
          css: css.inputField,
          onChange: onChange,
          onBlur: function onBlur(event) {
            _onBlur(event, onBlurFromProps);
          },
          onFocus: function onFocus(event) {
            _onFocus(event, onFocusFromProps);
          },
          type: "text",
          inputMode: "decimal",
          value: value,
          pattern: "^((\\d+(\\.\\d?\\d?)?)|(\\.\\d\\d?))$",
          ref: inputEl
        }, propsExcludeBlurAndFocus))]
      }), showIcon ? (0, _jsxRuntime.jsx)(_core.IconButton, {
        "aria-label": "edit",
        onClick: onEditClick,
        css: css.iconButton,
        children: theme.name === 'legacy' ? (0, _jsxRuntime.jsx)(Icons.Edit, {}) : (0, _jsxRuntime.jsx)("span", {
          css: {
            backgroundColor: theme.colors.primary.lightest,
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            ':hover': {
              backgroundColor: theme.colors.primary.lighter
            }
          },
          children: (0, _jsxRuntime.jsx)(_fearless.Pencil, {
            fill: theme.colors.accent,
            width: 20,
            height: 20
          })
        })
      }) : (0, _jsxRuntime.jsx)(ShowKeypadLink, {
        onClick: onEditClick,
        showKeypad: showKeypad
      })]
    }), errorMessage && (0, _jsxRuntime.jsx)("span", {
      css: css.error,
      children: errorMessage
    })]
  });
});
var _default = AmountInput;
exports["default"] = _default;